export default async synchronizer => {
    await synchronizer.$store.dispatch('app/setChainGlobal');
}
